<template>
  <div class="pioneer6-feature-section">
    <h1 class="feature-header">{{ sectionData.field_1 }}</h1>
    <div class="features-content">
      <div class="feature-wrapper" v-for="(item, index) in sectionData.items " :key="index">
        <div class="feature-img">
          <img :src="item.field_3" alt="Pioneer feature img">
        </div>
        <div class="feature-content">
          <p class="title">{{ item.field_1 }}</p>
          <p class="subtitle">{{ item.field_2 }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "pioneer6-features",
  props: {
    section: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      sectionData: {
        items: [],
      },
    };
  },
  mounted() {
    try {
      this.sectionData = JSON.parse(this.section);
    } catch (error) {
      console.error("Error parsing section JSON:", error);
    }
  }
}
</script>

<style lang="scss" scoped>
.pioneer6-feature-section {
  display: flex;
  flex-direction: column;
  gap: 40px;
  justify-content: center;
  align-items: center;
  background-image: url(https://assets.rhinorack.com/zwifloc/Topography.png);
  background-size: contain;
  padding: 100px 50px 94px 50px;
  margin-left: 15px;
  margin-right: 15px;
  border-radius: 15px;

  @media screen and (max-width: 425px) {
    padding: 72px 30px 54px 30px;
  }

  .feature-header {
    color: #FFFFFF;
    font-family: 'trim-medium';
    font-size: 32px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 39px;
    text-align: center;

    @media screen and (max-width: 767px) {
      font-size: 24px;
    }
  }

  .features-content {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 15px;

    .feature-wrapper {
      display: flex;
      flex-direction: column;
      gap: 24px;
      .feature-img {
        img {
          max-width: 386px;
          width: 100%;
          height: 289px;
          object-fit: cover;
          border-radius: 2%;
          box-shadow: 0 2px 14px 0 rgba(0,0,0,0.06);

          @media screen and (max-width: 425px) {
            height: 258px;
          }

          @media screen and (max-width: 375px) {
            height: 210px;
          }
        }
      }

      .feature-content {
        .title {

          color: #FFFFFF;
          font-family: 'trim-medium';
          font-size: 24px;
          font-weight: 500;
          letter-spacing: 0;
          line-height: 22px;
        }

        .subtitle {
          color: #FFFFFF;
          font-family: 'trim-light';
          font-size: 21px;
          font-weight: 300;
          letter-spacing: 0.46px;
          line-height: 23px;
          max-width: 350px;
        }
      }
    }

  }

}
</style>
